<template>
  <AGDialog
    v-for="dialog in dialogs"
    :key="dialog.id"
    v-model="dialog.isOpen"
    :scrollable="dialog.scrollable"
    :title="dialog.title"
    :persistent="dialog.persistent || dialog.loading.ok || dialog.loading.cancel"
    :max-width="dialog.maxWidth"
    :width="dialog.width"
    @close="onClose(dialog)"
    @click:outside="onDismiss(dialog)"
  >
    <div v-html="dialog.message" />

    <template #footer>
      <div class="ag-dialog-confirm__card-footer">
        <AGButton
          :type="dialog.cancel.type"
          :loading="dialog.loading.cancel"
          :disabled="dialog.loading.ok || dialog.loading.cancel"
          @click="onCancel(dialog)"
        >
          {{ dialog.cancel.label }}
        </AGButton>
        <AGButton
          :type="dialog.ok.type"
          :loading="dialog.loading.ok"
          :disabled="dialog.loading.ok || dialog.loading.cancel"
          @click="onOk(dialog)"
        >
          {{ dialog.ok.label }}
        </AGButton>
      </div>
    </template>
  </AGDialog>
</template>

<script>
import AGButton from '@/components/common/AGButton.vue';
import AGDialog from '@/components/common/AGDialog.vue';
import { inject } from 'vue';

export default {
  components: {
    AGButton,
    AGDialog,
  },
  setup() {
    const confirmManager = inject('confirmManager');
    return {
      dialogs: confirmManager.dialogs,
      confirmManager,
    };
  },
  methods: {
    onOk(dialog) {
      this.confirmManager.resolve(dialog.id, 'ok');
    },
    onCancel(dialog) {
      this.confirmManager.resolve(dialog.id, 'cancel');
    },
    onClose(dialog) {
      const isLoading = dialog.loading.ok || dialog.loading.cancel;
      if (dialog.persistent || isLoading) return;
      if (dialog.cancelOnClose) return this.confirmManager.resolve(dialog.id, 'cancel');
      this.confirmManager.resolve(dialog.id, 'close');
    },
    onDismiss(dialog) {
      const isLoading = dialog.loading.ok || dialog.loading.cancel;
      if (dialog.persistent || isLoading) return;
      if (dialog.cancelOnDismiss) return this.confirmManager.resolve(dialog.id, 'cancel');
      this.confirmManager.resolve(dialog.id, 'dismiss');
    },
  },
};
</script>

<style scoped lang="scss">
.ag-dialog-confirm__card-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px;
}
</style>
